import MainLayout from "components/MainLayout";
import Metadata from "components/Metadata";
import React from "react";

export default function HiringGuidePage() {
  return (
    <MainLayout>
      <Metadata
        title="What to Know When Hiring a Bagpiper | Pipers For Hire"
        description="Our hiring guide explains the process of hiring a piper, what questions to ask, and other tips in selecting a bagpiper."
        url="https://pipersforhire.com/hiring-a-bagpiper"
      />
      <h1 className="text-2xl font-bold text-theme-blue">Hiring a bagpiper</h1>
      <p className="mt-4">
        Pipers For Hire makes it easy to search for and find local bagpipers so
        clients can contact multiple bagpipers for quotes. For those who are
        hiring a bagpiper for the first time – this guide explains the process
        and ensures you know what information is important.
      </p>
      <p className="mt-4">
        Every occasion deserves a quality bagpiper who represents the instrument
        well and comes at a reasonable price. When requesting a quote, the key
        information needed is:
      </p>

      <div className="mt-12">
        <h3 className="text-xl font-semibold">1) Location and time</h3>
        <p className="mt-2">
          Providing the event address will help the bagpiper access if they will
          be able to travel to the event on time or if any travel costs will be
          included. For the time, it&apos;s important to know not only when
          you&apos;d like the music to start, but also for how long you&apos;d
          like the performance to be. Bagpipers typically need some extra time
          to warm-up and tune the bagpipes prior to performing, so timing is a
          crucial factor.
        </p>
        <h3 className="mt-8 text-xl font-semibold">
          2) Special requests and logistics
        </h3>
        <p className="mt-2">
          This topic could cover the timing of the performance (i.e. before,
          during, or after a service), certain tunes you want played, if
          you&apos;re looking for multiple players/mini-band, or whether
          it&apos;s meant to be a surprise. The more detail you can provide
          upfront, the greater the likelihood the bagpiper will understand
          exactly what you&apos;re looking for in the performance. If
          you&apos;re still in the planning stages and are looking for advice –
          a truly great piper will have recommendations based on their past
          experiences!
        </p>
        <h3 className="mt-8 text-xl font-semibold">
          3) Check if there&apos;s a deposit
        </h3>
        <p className="mt-2">
          Most bagpipers will ask for a deposit if the event date is a month or
          more out. Especially during peak seasons and holidays (such as wedding
          season, St. Patrick&apos;s Day, graduations, etc.) bagpipers might get
          multiple inquiries and use deposits to hold a date. Learn more about
          the cost of hiring a bagpiper below.
        </p>
      </div>

      <h2 className="mt-12 text-xl font-semibold">
        The cost of hiring a bagpiper
      </h2>
      <p className="mt-4">
        Several factors can go into the total cost of hiring a bagpiper. These
        can include the length of the performance and any travel expenses (ex.
        tolls and gas). Additional factors like the bagpiper&apos;s years of
        experience or the local market economics might influence the quote.
        It&apos;s also helpful to know that even if the musical performance
        itself only lasts 20 minutes, the bagpiper is still investing time
        &quot;behind the scenes&quot; including bagpipe maintenance, dressing in
        uniform, traveling to and from the venue, pre-event rehearsals,
        transposing and memorizing special tune requests, etc. (not to mention
        the financial investment to maintain the instrument and uniform!) So
        what on the surface might appear as a 20 minute engagement could in
        reality add up to several hours in total. Each bagpiper will have their
        own method for determining the final cost, but knowing it&apos;s a
        combination of factors can help explain some differences in price range.
      </p>
    </MainLayout>
  );
}
